import React, { useState, useEffect, useMemo } from "react";
import {
    Form,
    Input,
    FormInstance,
    Cascader,
    TreeSelect,
    Spin,
    Space,
    Button,
    Row,
    Col,
    Upload,
    notification, Select, Table, Image, Radio, Tooltip, Tag,
    InputNumber,
    Collapse,
    TimePicker
} from "antd";
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {
    deleteTemplateDock, addTemplateDock, getTemplateDock
} from "../../../axios/api.device"
import {
    getMacNativeApps
} from "../../../axios/api.app"

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";
import dayjs from 'dayjs';

const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentDock = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [dataForm] = Form.useForm();
    const { t } = useTranslation();

    const [dockOptions, setDockOptions] = useState<any>([]);

    // 监听 Form.List 的值变化，用于过滤已选项
    const selectedApps = Form.useWatch('persistentApps', dataForm) || [];

    //
    useEffect(() => {
        const loadOptions = async () => {
            try {
                const res = await getMacNativeApps();
                const formattedOptions = res.map(item => ({
                    value: item.path,
                    label: item.name
                }));
                setDockOptions(formattedOptions);
            } catch (error) {
                notification.error({ message: t("获取应用列表失败") });
            }
        };
        loadOptions();
    }, []);

    // 根据当前行的索引，过滤掉其他行已经选中的选项
    const getFilteredOptions = (currentIndex: number) => {
        //console.log(selectedApps);
        if (!selectedApps) return dockOptions;
        
        // 收集所有其他行已经选中的 value
        const selectedValues: string[] = selectedApps
        .map((item: any, index: number) => (index !== currentIndex ? item : null))
        .filter(Boolean);

        // 返回未被其他行选中的选项
        return dockOptions.filter((option: any) => !selectedValues.includes(option.value));
    };

    var addClick = () => {
        setShowTable(2)
    }
    useEffect(() => {
        getDataInfo()
    }, [])
    const getDataInfo = () => {
        getTemplateDock(templateId).then((res) => {
            if (res && res != null && res.orientation) {
                setShowTable(2)
                const formattedValues = res.persistentApps?.map((item: any) => item.path) || [];
                res.persistentApps = formattedValues;
                dataForm?.setFieldsValue(res);
            } else {
                setShowTable(1)
            }
        })
    }

    const addTemplateClick = () => {
        dataForm?.validateFields().then(
            (res) => {
                console.log(res);
                // 将 value 数组转换成包含 value 和 label 的对象数组
                const formattedApps = res.persistentApps.map((path: String) => {
                    // 从 dockOptions 中找到对应的选项
                    const matchedOption = dockOptions.find((option:any) => option.value === path);
                    
                    return {
                        path: path,
                        label: matchedOption ? matchedOption.label : '', // 如果找不到就返回空字符串
                        tileType: 'file-tile',
                        fileType: 1
                    };
                });

                const submitData = {
                    ...res,
                    persistentApps: formattedApps
                };
                addTemplateDock(templateId, submitData).then(() => {
                    updateTemplate();
                    notification.success({ message: t("成功") });
                    getDataInfo();
                })
                // if (res.powerOnTime) {
                // // 将 dayjs 对象转换为整数分钟数
                //     res.powerOnTime = res.powerOnTime.hour() * 60 + res.powerOnTime.minute();
                // }
                // if (res.powerOffTime) {
                //     res.powerOffTime = res.powerOffTime.hour() * 60 + res.powerOffTime.minute();
                // }
                // console.log(res);
                // addTemplateEnergySaver(templateId, res).then(() => {
                //     updateTemplate();
                //     notification.success({ message: t("成功") });
                //     getDataInfo();
                // })
            })
    }
    const deleteTemplateClick = () => {
        dataForm.validateFields().then(() => {
            deleteTemplateDock(templateId).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                dataForm.resetFields();
                getDataInfo();
            })
        })

    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle"> {t("Dock栏")}</Col>
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (

                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("设置Dock栏")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <>
                        <Form
                            style={{ width: "90%", marginTop: 36 }}
                            layout="horizontal"
                            form={dataForm}
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 14 }}
                            initialValues={{ tilesize: 16, orientation: 'left', 
                                minimizeToApplication: 'None', autoHide: 'None'
                              }}
                        >
                            <Item
                                label={t("Dock栏尺寸")}
                                name="tilesize"
                            >
                                <Select style={{width:"40%"}}>
                                    <Select.Option value={16}>{t("16")}</Select.Option>
                                    <Select.Option value={32}>{t("32")}</Select.Option>
                                    <Select.Option value={48}>{t("48")}</Select.Option>
                                    <Select.Option value={64}>{t("64")}</Select.Option>
                                    <Select.Option value={80}>{t("80")}</Select.Option>
                                    <Select.Option value={96}>{t("96")}</Select.Option>
                                    <Select.Option value={112}>{t("112")}</Select.Option>
                                    <Select.Option value={128}>{t("128")}</Select.Option>
                                </Select>
                            </Item>
                            <Item
                                label={t("位置")}
                                name="orientation"
                            >
                                <Select style={{width:"40%"}}>
                                    <Select.Option value={'left'}>{t("居左")}</Select.Option>
                                    <Select.Option value={'bottom'}>{t("居中")}</Select.Option>
                                    <Select.Option value={'right'}>{t("居右")}</Select.Option>
                                </Select>
                            </Item>
                            <Item
                                label={t("最小化窗口到应用图标")}
                                name="minimizeToApplication"
                            >
                                <Select style={{width:"40%"}}>
                                    <Select.Option value={'None'}>{t("暂不设置")}</Select.Option>
                                    <Select.Option value={'Enable'}>{t("启用")}</Select.Option>
                                    <Select.Option value={'Disable'}>{t("禁用")}</Select.Option>
                                </Select>
                            </Item>
                             <Item
                                label={t("自动隐藏展示Dock栏")}
                                name="autoHide"
                            >
                                <Select style={{width:"40%"}}>
                                    <Select.Option value={'None'}>{t("暂不设置")}</Select.Option>
                                    <Select.Option value={'Enable'}>{t("启用")}</Select.Option>
                                    <Select.Option value={'Lock'}>{t("锁定自动隐藏")}</Select.Option>
                                </Select>
                            </Item>
                            <Form.Item label="Dock栏应用" className="custom-form-spacing">
                                <Form.List name="persistentApps">
                                {(fields, { add, remove }) => (
                                    <>
                                        {fields.map((field) => (
                                            <Form.Item >
                                                <Row justify="space-between" key={field.key}>
                                                    <Col span="21">
                                                        <Form.Item 
                                                            style={{ flex: 1, marginBottom: 0 }}
                                                            {...field}
                                                            //name={[field.name]}
                                                            rules={[{ required: true, message: '请选择应用' }]}
                                                        >
                                                            <Select 
                                                                options={getFilteredOptions(field.name)}
                                                                placeholder="请选择应用"
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col>
                                                        <Button type="dashed" onClick={() => { remove(field.name) }}>-</Button>
                                                    </Col>
                                                </Row>
                                            </Form.Item>
                                        ))}
                                        <Form.Item>
                                            <Button type="dashed" onClick={() => { add() }} block>
                                                <PlusOutlined />{t("添加Dock栏应用")}
                                            </Button>
                                        </Form.Item>
                                    </>
                                )}
                                </Form.List>
                            </Form.Item>
                        </Form>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); }}>{t("删除规则")}</Button>
                        </div>
                    </>
                )}
            </Row>
        </div>

    </>)
};